import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../authorization/authService";

export const commentApi = createApi({
  reducerPath: "commentApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Comment"],
  endpoints: (builder) => ({
    // ✅ Dynamic query for both application and report comments
    getComments: builder.query({
      query: ({ application_id, report_id }) => {
        const queryParams = new URLSearchParams();
        if (application_id)
          queryParams.append("application_id", application_id.toString());
        if (report_id) queryParams.append("report_id", report_id.toString());

        return {
          url: `/comment?${queryParams.toString()}`,
          method: "GET",
        };
      },
      providesTags: (result, error, { application_id, report_id }) => [
        { type: "Comment", id: application_id || report_id },
      ],
    }),

    createComment: builder.mutation({
      query: (commentData) => ({
        url: `/comment`,
        method: "POST",
        body: commentData,
      }),
      invalidatesTags: (result, error, { application_id, report_id }) => [
        { type: "Comment", id: application_id || report_id },
      ],
    }),

    updateComment: builder.mutation({
      query: ({ comment_id, commentData }) => ({
        url: `/comment/${comment_id}`,
        method: "PUT",
        body: commentData,
      }),
      invalidatesTags: (result, error, { application_id, report_id }) => [
        { type: "Comment", id: application_id || report_id },
      ],
    }),

    deleteComment: builder.mutation({
      query: ({ comment_id }) => ({
        url: `/comment/${comment_id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { application_id, report_id }) => [
        { type: "Comment", id: application_id || report_id },
      ],
    }),
  }),
});

export const {
  useGetCommentsQuery,
  useCreateCommentMutation,
  useUpdateCommentMutation,
  useDeleteCommentMutation,
} = commentApi;
